var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon77(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7.99984C1.6665 5.01428 1.6665 3.5215 2.594 2.594C3.5215 1.6665 5.01428 1.6665 7.99984 1.6665C10.9854 1.6665 12.4782 1.6665 13.4057 2.594C14.3332 3.5215 14.3332 5.01428 14.3332 7.99984C14.3332 10.9854 14.3332 12.4782 13.4057 13.4057C12.4782 14.3332 10.9854 14.3332 7.99984 14.3332C5.01428 14.3332 3.5215 14.3332 2.594 13.4057C1.6665 12.4782 1.6665 10.9854 1.6665 7.99984Z",
    stroke: "#686C70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 9L4.99984 6L6.24984 9M3.99984 9L3.6665 10M3.99984 9H6.24984M6.24984 9L6.6665 10",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 8V6.46667C8.3335 6.34258 8.3335 6.28054 8.34983 6.23033C8.38276 6.12885 8.46236 6.04929 8.56383 6.01631C8.61403 6 8.6761 6 8.80016 6H9.66683C10.2191 6 10.6668 6.44771 10.6668 7C10.6668 7.55227 10.2191 8 9.66683 8H8.3335ZM8.3335 8V10",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 6V10",
    stroke: "#686C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon77);
export default __webpack_public_path__ + "static/media/sidbaricon77.41310dba643199fbfc99d370032aadbe.svg";
export { ForwardRef as ReactComponent };